import { render } from "./NoAccess.vue?vue&type=template&id=258943b4&scoped=true"
import script from "./NoAccess.vue?vue&type=script&lang=js"
export * from "./NoAccess.vue?vue&type=script&lang=js"

import "./NoAccess.vue?vue&type=style&index=0&id=258943b4&scoped=true&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-258943b4"]])

export default __exports__